import { getAnalytics, logEvent } from "firebase/analytics";
import { analytics } from "../App";
import { isDev } from "../constant/Constant";

export const sendViewEvent =(pathName)=> {
    console.log('isDev----'+isDev);
    !isDev && logEvent(analytics,pathName)
}